import EpisodeDuration from './EpisodeDuration';

const { registerPlugin } = wp.plugins;

/**
 * Registers 'idg-base-theme-start-date-link-blogseries' plugin in the Posts Settings Sidebar.
 */
wp.domReady(() => {
	registerPlugin('ib-wow-podcast-episode-duration', {
		render: EpisodeDuration,
		icon: '',
	});
});
